import React, { useState } from "react";
import { useParams } from "react-router-dom";
import emailjs from "emailjs-com";

import Sidebar from "./Sidebar";
import currentStudiesData from "../../data/current-studies.json";

export default function SingleBlog() {
  // Study details
  const { id } = useParams();
  const study = currentStudiesData.studies.find((s) => s.id === parseInt(id));

  // Form details
  // State for form fields
  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    phone: "",
    status: "",
    message: "",
    hearAboutUs: "",
  });

  // State for participant list form
  const [participantEmail, setParticipantEmail] = useState("");
  const [participantAlert, setParticipantAlert] = useState({
    show: false,
    type: "",
    message: "",
  });
  const [isParticipantLoading, setIsParticipantLoading] = useState(false);

  // State for loading and alert
  const [isLoading, setIsLoading] = useState(false);
  const [alert, setAlert] = useState({ show: false, type: "", message: "" });

  // Handle input change
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  // Handle form submission
  const handleSubmit = (e) => {
    e.preventDefault();
    setIsLoading(true);
    setAlert({ show: false, type: "", message: "" });

    // Set the status to the study title and ID
    formData.status = `${study.title} - ${study.id}`;
    formData.message = `This person is contacting you to join the study: ${study.title}`;

    // Send email using EmailJS
    emailjs
      .send(
        "service_zgh2ksd", // Replace with your EmailJS service ID
        "template_cokkqp7", // Replace with your EmailJS template ID
        formData,
        "USX72MTx26hcTNM95" // Replace with your EmailJS user/public key
      )
      .then(
        (response) => {
          setAlert({
            show: true,
            type: "success",
            message:
              "Your message has been sent successfully! We'll get back to you soon.",
          });
          setFormData({
            fullName: "",
            email: "",
            phone: "",
            status: "",
            message: "",
            hearAboutUs: "",
          });
        },
        (error) => {
          setAlert({
            show: true,
            type: "danger",
            message:
              "Failed to send message. Please try again or contact us directly.",
          });
        }
      )
      .finally(() => {
        setIsLoading(false);
      });
  };

  // Handle participant list submission
  const handleParticipantSubmit = (e) => {
    e.preventDefault();
    setIsParticipantLoading(true);
    setParticipantAlert({ show: false, type: "", message: "" });

    emailjs
      .send(
        "service_zgh2ksd",
        "template_cokkqp7",
        {
          email: participantEmail,
          status: "participant-list",
          message: "New participant list subscription",
        },
        "USX72MTx26hcTNM95"
      )
      .then(
        (response) => {
          setParticipantAlert({
            show: true,
            type: "success",
            message: "Thank you for joining our participant list!",
          });
          setParticipantEmail("");
        },
        (error) => {
          setParticipantAlert({
            show: true,
            type: "danger",
            message: "Failed to subscribe. Please try again.",
          });
        }
      )
      .finally(() => {
        setIsParticipantLoading(false);
      });
  };

  if (!study) {
    return (
      <div className="container py-5">
        <div className="alert alert-danger">Study not found</div>
      </div>
    );
  }
  const studyImage = require(`../../images/current-studies/${study.image}`);

  return (
    <>
      <div className="module ptb-100">
        <div className="container">
          <div className="row">
            <div className="col-md-8">
              <article className="post">
                <div className="post-preview">
                  <img
                    src={studyImage}
                    style={{ borderRadius: "10px" }}
                    className="img-fluid"
                  />
                </div>
              </article>
            </div>
            <div className="col-md-4">
              <form onSubmit={handleSubmit} className="contact-us-form">
                <h5 className="mt-4">Sign Up Now</h5>
                <div className="row">
                  <div className="col-12">
                    <div className="form-group">
                      <input
                        type="text"
                        name="fullName"
                        className="form-control"
                        placeholder="Full Name*"
                        required
                        value={formData.fullName}
                        onChange={handleChange}
                        disabled={isLoading}
                      />
                    </div>
                  </div>
                  <div className="col-12">
                    <div className="form-group">
                      <input
                        type="email"
                        name="email"
                        className="form-control"
                        placeholder="Email"
                        value={formData.email}
                        onChange={handleChange}
                        disabled={isLoading}
                      />
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-12">
                    <div className="form-group">
                      <input
                        type="text"
                        name="phone"
                        className="form-control"
                        placeholder="Phone Number*"
                        required
                        value={formData.phone}
                        onChange={handleChange}
                        disabled={isLoading}
                      />
                    </div>
                  </div>

                  <div className="col-12">
                    <div className="form-group">
                      <input
                        type="text"
                        name="hearAboutUs"
                        className="form-control"
                        placeholder="How did you hear about us?"
                        value={formData.hearAboutUs}
                        onChange={handleChange}
                        disabled={isLoading}
                      />
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-sm-12 mt-3">
                    <button
                      type="submit"
                      className="btn solid-btn"
                      disabled={isLoading}
                    >
                      {isLoading ? (
                        <>
                          <span
                            className="spinner-border spinner-border-sm mr-2"
                            role="status"
                            aria-hidden="true"
                          ></span>
                          Sending...
                        </>
                      ) : (
                        <>Submit</>
                      )}
                    </button>
                  </div>
                </div>
              </form>

              {alert.show && (
                <div className="mt-4 col-12 pb-3">
                  <div
                    className={`alert alert-${alert.type} alert-dismissible fade show`}
                    role="alert"
                  >
                    {alert.message}
                    <button
                      type="button"
                      className="close"
                      onClick={() =>
                        setAlert({ show: false, type: "", message: "" })
                      }
                    >
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                </div>
              )}
              <hr style={{ marginTop: "3rem", marginBottom: "3rem" }} />
              <aside className="widget widget-categories">
                <h5 className="mt-4">Join Future Studies</h5>
                <p>
                  Sign up to our newsletter to get information about future
                  studies
                </p>
                {participantAlert.show && (
                  <div
                    className={`alert alert-${participantAlert.type} alert-dismissible fade show`}
                    role="alert"
                  >
                    {participantAlert.message}
                    <button
                      type="button"
                      className="close"
                      onClick={() =>
                        setParticipantAlert({
                          show: false,
                          type: "",
                          message: "",
                        })
                      }
                    >
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                )}
                <form
                  onSubmit={handleParticipantSubmit}
                  className="participant-form"
                >
                  <div className="form-group">
                    <div className="input-group">
                      <input
                        type="email"
                        className="form-control"
                        placeholder="Enter your email address"
                        value={participantEmail}
                        onChange={(e) => setParticipantEmail(e.target.value)}
                        required
                        disabled={isParticipantLoading}
                      />

                      <button
                        disabled={isParticipantLoading}
                        type="submit"
                        className="btn solid-btn btn-block btn-not-rounded mt-3 mr-3 ml-3"
                      >
                        Subscribe
                      </button>
                    </div>
                  </div>
                </form>
              </aside>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
